import DownTimeScreen from '@/components/DownTimeScreen';
import { ErrorBoundary } from 'react-error-boundary';

export function TopLevelErrorBoundary({ children }: { children: React.ReactNode }) {
  return <ErrorBoundary fallback={<DownTimeScreen />}>{children}</ErrorBoundary>;
}
